
import { Options, Vue } from "vue-class-component";
import axios from "axios";
import { ADDRESS, imageUrl } from "@/settings";

export default class BlogForm extends Vue {
  doc:any = {}
  address = ADDRESS;
  imageUrl = imageUrl;
  mounted() {
    if (this.$route.params.id != undefined) this.fetchData();
  }
  async fetchData() {
    let response = await axios.get(`${ADDRESS}/blog/get/${this.$route.params.id}`);
    this.doc = response.data.doc;
  }
  async submitForm() {
    if (this.$route.params.id != undefined) {
      axios.patch(`${ADDRESS}/blog/update/${this.$route.params.id}`, {
        ...this.doc,
      }).then((response) => {
        alert("แก้ไขข้อมูลแล้ว!")
        this.$router.push('/portal/blog')
      });
    } else {
      axios.post(`${ADDRESS}/blog/create`, {
        ...this.doc,
      }).then((response) => {
        alert("บันทึกสำเร็จ!")
        this.$router.push('/portal/blog')
      });
    }
  }

}
